import styled from "styled-components";
import { Link } from "react-router-dom";

export const Column = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};

  @media (max-width: 520px) {
    width: 100%;
  }
`;

export const InputFlex = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
  width: 350px;

  @media (max-width: 520px) {
    width: 100%;
  }
`;

export const SupportContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 2rem;
  align-items: center;
`;

export const LinkContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
`;

export const SupportLink = styled(Link)`
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    text-shadow: ${({ theme }) => theme.colors.primary} 0 0 0;
  }

  &.active {
    color: ${({ theme }) => theme.colors.primary};
    text-shadow: ${({ theme }) => theme.colors.primary} 0 0 0;
  }
`;

export const StyledLink = styled(Link)`
  font-size: inherit;
  font-weight: 500;
  text-underline-offset: 5px;
  color: ${({ theme }) => theme.colors.text};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    text-shadow: ${({ theme }) => theme.colors.primary} 0 0 0;
    text-decoration: none;
  }

  &.active {
    color: ${({ theme }) => theme.colors.primary};
    text-shadow: ${({ theme }) => theme.colors.primary} 0 0 0;
    text-decoration: none;
  }
`;

export const LoginLinkContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  align-items: center;
  justify-content: center;
`;

export const LoginLink = styled(Link)`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  font-size: 1rem;
  font-weight: 500;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    text-shadow: ${({ theme }) => theme.colors.primary} 0 0 0;
    text-decoration: none;
  }

  &.active {
    color: ${({ theme }) => theme.colors.primary};
    text-shadow: ${({ theme }) => theme.colors.primary} 0 0 0;
    text-decoration: none;
  }
`;
